import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Copy, Save, Contact } from "lucide-react";
import { downloadInboxVcard } from "@/lib/vcard";

export default function InboxSettings() {
  const [cfg, setCfg] = useState(null);
  const [email, setEmail] = useState("");
  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    api.get("/inbound/config").then((r) => { setCfg(r.data); setEmail(r.data.inbound_email || ""); }).catch(() => {});
  }, []);

  const webhookUrl = cfg ? `${BACKEND}/api/inbound/webhook?key=${cfg.inbound_key}` : "";
  const save = async () => {
    try { await api.put("/inbound/config", { inbound_email: email }); toast.success("Doorstuuradres opgeslagen"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Opslaan mislukt"); }
  };
  const copy = () => { navigator.clipboard.writeText(webhookUrl); toast.success("Gekopieerd"); };

  return (
    <Card className="p-6 space-y-5" data-testid="inbox-settings-card">
      <div>
        <h3 className="font-heading font-semibold">Postvak — doorsturen</h3>
        <p className="text-sm text-slate-500">Mails die naar het doorstuuradres gaan, komen via de webhook binnen in het Postvak.</p>
      </div>
      <div className="space-y-2">
        <Label>Doorstuuradres (inbound-adres bij je e-mailprovider, bijv. Postmark)</Label>
        <div className="flex gap-2 flex-wrap">
          <Input className="max-w-md" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="bijv. abc123@inbound.postmarkapp.com" data-testid="inbox-settings-email-input" />
          <Button onClick={save} data-testid="inbox-settings-save"><Save className="h-4 w-4 mr-2" /> Opslaan</Button>
          <Button variant="outline" disabled={!email} onClick={() => downloadInboxVcard(email)} data-testid="inbox-settings-vcard"><Contact className="h-4 w-4 mr-2" /> Contact voor Outlook</Button>
        </div>
      </div>
      {webhookUrl && (
        <div className="space-y-2">
          <Label>Resend-webhook (event: email.received)</Label>
          <div className="flex items-center gap-2">
            <code className="text-xs bg-slate-50 border rounded px-2 py-1.5 break-all" data-testid="inbox-resend-webhook-url">{`${BACKEND}/api/inbound/resend`}</code>
            <Button size="sm" variant="ghost" onClick={() => { navigator.clipboard.writeText(`${BACKEND}/api/inbound/resend`); toast.success("Gekopieerd"); }} data-testid="inbox-copy-resend-webhook"><Copy className="h-3.5 w-3.5" /></Button>
          </div>
          <p className="text-xs text-slate-500">Mails die u zelf verstuurt met het doorstuuradres in CC worden automatisch gekoppeld als er precies één debiteur in Aan/CC staat; anders krijgt u een suggestie (ook op naam of KL-/DOS-/OVK-nummer in de tekst).</p>
        </div>
      )}
      {webhookUrl && (
        <div className="space-y-2">
          <Label>Webhook-URL (Postmark / overige)</Label>
          <div className="flex items-center gap-2">
            <code className="text-xs bg-slate-50 border rounded px-2 py-1.5 break-all" data-testid="inbox-webhook-url">{webhookUrl}</code>
            <Button size="sm" variant="ghost" onClick={copy} data-testid="inbox-copy-webhook"><Copy className="h-3.5 w-3.5" /></Button>
          </div>
        </div>
      )}
    </Card>
  );
}
